/** 行ごとの選択と「すべて選択」に使う小さなチェックボックス。押せる範囲は見た目より広く取る */

import { Check, Minus } from 'lucide-react'

import { cn } from '@/lib/utils'

type Props = {
  checked: boolean | 'mixed'
  onToggle: () => void
  label: string
  className?: string
}

export const SelectBox = ({ checked, onToggle, label, className }: Props) => (
  <button
    type="button"
    role="checkbox"
    aria-checked={checked}
    aria-label={label}
    onClick={onToggle}
    className={cn('group flex size-8 shrink-0 items-center justify-center rounded-md hover:bg-muted', className)}
  >
    <span
      className={cn(
        'flex size-4 items-center justify-center rounded-[4px] border transition-colors',
        checked ? 'border-primary bg-primary text-primary-foreground' : 'border-muted-foreground/40 bg-background',
      )}
    >
      {checked === 'mixed' ? <Minus size={12} strokeWidth={3} /> : checked && <Check size={12} strokeWidth={3} />}
    </span>
  </button>
)
